import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Space, Avatar, Typography, Switch } from 'antd';
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons';
import { useParams, useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getRideDetails, updateRideImage } from 'actions/rides';
import { connect } from 'react-redux';
import { formatToDateString, getInitials } from 'utility/helperFunctions';
import { RideListData } from './RideListData/RideListData';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { TransactionDetails } from 'views/TransactionDetails/TransactionDetails';
import { getPayoutList, addPayout } from '../../actions/payout';
import RideImageContainer from './rideImageContainer';

const { Title, Text } = Typography;

const RideDetailsPage = (props) => {
    const { rideId } = useParams();
    return <RideDetailsComponent rideId={rideId} {...props} />;
};

const formatAmount = (amount) => {
    return `${amount.toLocaleString('en-IN')}`;
};


const CustomTabNavigation = ({ activeTab, onTabChange }) => {
    const tabs = [
        {
            key: 'riders',
            label: 'Riders Details'
        },
        {
            key: 'transactions',
            label: 'Payouts'
        }
    ];

    return (
        <div style={{
            display: 'flex',
            borderBottom: '1px solid #e2e2e2',
            width: '80%',
            fontWeight: '500',
            marginBottom: '10px'
        }}>
            {tabs.map(tab => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    style={{
                        fontFamily: 'Roboto, sans-serif',
                        lineHeight: '100%',
                        padding: '12px 24px',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: '20px',
                        fontWeight: '500',
                        color: activeTab === tab.key ? '#6528D8' : '#000',
                        borderBottom: activeTab === tab.key ? '2px solid #6528D8' : '2px solid transparent',
                        transition: 'all 0.3s ease'
                    }}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

const Header = ({ handleBackClick, rideDetails, handleDownload, activeTab }) => (
    <div
        className="header"
        style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '80%',
            marginBottom: '16px',
        }}
    >
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
                icon={<ArrowLeftOutlined style={{ color: 'black' }} />}
                onClick={handleBackClick}
                type="link"
                style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            />

            <Title level={4} style={{ margin: '10px', marginLeft: '16px' }}>
                {rideDetails?.name ?? 'N/A'}
            </Title>
        </div>
        <Button
            icon={<DownloadOutlined />}
            onClick={handleDownload}
            style={{
                border: '1px solid #8e44ad',
                color: '#6528D8',
                borderRadius: '6px',
            }}
        >
            {activeTab === 'riders' ? 'Download Riders Details' : 'Download Payouts Details'}
        </Button>
    </div>
);


const RideInformation = ({ rideDetails }) => {

    const rideCreator = rideDetails?.rideMembers?.find(
        member => member.userId === rideDetails?.createdBy
    );

    return (
        <Card
            style={{
                marginBottom: 24,
                borderRadius: '8px',
                width: '80%',
                backgroundColor: '#fff',
                border: '1px solid #eaeaea',
            }}
            bodyStyle={{ padding: 24 }}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <Space direction="vertical" size={15}>
                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                RIDE NAME
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>{rideDetails?.name}</Text>
                        </div>
                        <div style={{ marginTop: '26px' }}>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                FROM → TO
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {rideDetails?.rideDetails[0]?.startPoint?.displayName ?? "N/A"} → {rideDetails?.headedTo?.displayName ?? "N/A"}
                            </Text>
                        </div>
                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                CREATION DATE
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {formatToDateString(rideDetails?.createdAt) ?? 'N/A'}
                            </Text>
                        </div>
                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                RIDE START DATE
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {formatToDateString(rideDetails?.startDateTime) ?? 'N/A'}
                            </Text>
                        </div>
                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                PRIVACY
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {rideDetails?.isRidePublic != null ? (rideDetails?.isRidePublic ? 'Public' : 'Private') : 'N/A'}
                            </Text>
                        </div>

                    </Space>
                </Col>

                <Col span={12}>
                    <Space direction="vertical" size={15}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                RIDE CREATOR
                            </Text>
                            <Space style={{ marginTop: '-4px', fontSize: '16px' }}>
                                <Avatar
                                    style={{ backgroundColor: "#87d068", marginRight: 10 }}
                                    src={rideCreator?.profilePic}
                                >
                                    {(!rideCreator?.profilePic && rideCreator)
                                        ? getInitials(rideCreator?.firstName, rideCreator?.lastName)
                                        : ''}
                                </Avatar>
                                <div>
                                    <Text strong style={{ display: 'block', fontSize: '16px' }}>
                                        {rideCreator?.firstName || 'N/A'} {rideCreator?.lastName || ''}
                                    </Text>
                                    <Text type="secondary" style={{ fontStyle: 'italic' }}>
                                        @{rideCreator?.userName || 'N/A'}
                                    </Text>
                                </div>
                            </Space>
                        </div>
                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                RIDE CATEGORY
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {rideDetails?.association ?? 'N/A'}
                            </Text>
                        </div>
                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                GROUP NAME
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {(rideDetails?.association === 'GROUP' && rideDetails?.type === 'OTHERS')
                                    ? rideDetails?.group?.name ?? 'N/A'
                                    : '-'
                                }
                            </Text>
                        </div>

                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                RIDE TYPE
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {rideDetails?.type ?? 'N/A'}
                            </Text>
                        </div>
                        <div>
                            <Text style={{ color: '#606060', fontSize: '14px', fontStyle: 'Roboto' }} type="secondary">
                                PRICE
                            </Text>
                            <Text style={{ display: 'block', fontSize: '16px' }}>
                                {rideDetails?.rideCharge
                                    ? rideDetails?.rideCharge?.isSplit
                                        ? 'Split'
                                        : `Rs. ${formatAmount(rideDetails?.rideCharge?.amount)}`
                                    : 'Free'}
                            </Text>
                        </div>
                    </Space>
                </Col>
            </Row >
        </Card >
    )
};




const RideDetails = ({ rideId, getRideDetails, rideDetails, payoutList, getPayoutList, addPayout, updateRideImage }) => {
    const [activeTab, setActiveTab] = useState('riders')
    const history = useHistory();

    useEffect(() => {
        if (rideId) {
            getRideDetails(rideId);
            getPayoutList(rideId);
        }
    }, [rideId]);


    const handleBackClick = () => {
        history.push('/rides');
    };

    const today = new Date();

    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();

    const hh = String(today.getHours()).padStart(2, '0');
    const min = String(today.getMinutes()).padStart(2, '0');

    const rideName = rideDetails?.name.replace(/\s+/g, '');

    const formattedDate = `${dd}${mm}${yyyy}`;
    const formattedTime = `${hh}${min}`;


    const handleDownload = async () => {
        const element = document.querySelector('.tab-content-section');

        const canvas = await html2canvas(element, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let yPosition = 0;

        while (yPosition < imgHeight) {
            pdf.addImage(imgData, 'PNG', 0, -yPosition, imgWidth, imgHeight);
            yPosition += pageHeight;
            if (yPosition < imgHeight) {
                pdf.addPage();
            }
        }

        const fileName = activeTab === 'riders'
            ? `${rideName}-riders-details-${formattedDate}-${formattedTime}`
            : `${rideName}-payout-details-${formattedDate}-${formattedTime}`;

        pdf.save(fileName);
    };

    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'riders':
                return <RideListData rideDetails={rideDetails} rideId={rideId} riders={rideDetails?.rideMembers || []} />;
            case 'transactions':
                return (
                    <TransactionDetails
                        payoutList={payoutList}
                        rideId={rideId}
                        rideDetails={rideDetails}
                        getPayoutList={getPayoutList}
                        addPayout={addPayout}
                    />
                );
            default:
                return <RideListData
                    rideDetails={rideDetails}
                    riders={rideDetails?.rideMembers || []}
                    rideId={rideId} />;
        }
    };


    return (
        <div
            className="ride-details-page tab-content-section"
            style={{ padding: '24px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >

            <Header
                handleBackClick={handleBackClick}
                rideDetails={rideDetails}
                handleDownload={handleDownload}
                activeTab={activeTab}
            />

            <RideImageContainer
                rideDetails={rideDetails}
                rideId={rideId}
                updateRideImage={updateRideImage}
                getRideDetails={getRideDetails}
            />

            <RideInformation rideDetails={rideDetails} />

            <CustomTabNavigation activeTab={activeTab} onTabChange={handleTabChange} />

            <div style={{ width: "80%" }}>
                {renderTabContent()}
            </div>

        </div>
    );
};

function mapStateToProps(state, ownProps) {
    const rideId = ownProps ? ownProps.rideId : undefined;
    return {
        rideDetails: rideId && state.Ride ? state.Ride[rideId] : {},
        payoutList: state.Payout ? state.Payout.payoutList : [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getRideDetails: bindActionCreators(getRideDetails, dispatch),
        getPayoutList: bindActionCreators(getPayoutList, dispatch),
        addPayout: bindActionCreators(addPayout, dispatch),
        updateRideImage: bindActionCreators(updateRideImage, dispatch),
    };
}

const RideDetailsComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(RideDetails);

export default RideDetailsPage;
